import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { ZpDataService } from "src/app/services/zp-data.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-create-account",
    templateUrl: "./create-account.component.html",
    styleUrls: ["./create-account.component.scss"],
    standalone: false
})
export class CreateAccountComponent {
  customers: any[];

  constructor(
    private router: Router,
    private api: ZpDataService,
    public themeService: ThemeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService
  ) {}

  ngOnInit(): void {
    this.customers = [];
    this.api.getCustomers().then((customers) => {
      this.customers = customers;
      console.log("All customers: ", this.customers);
    });
  }

  createAccount() {
    this.router.navigate(['/add-clients'], { queryParams: { createAccount: true } });
  }

  sendInvite() {
    this.router.navigate(['/add-clients'], { queryParams: { createAccount: false } });
  }
}
